import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { handleAuthRedirect, AuthProvider } from '@micronet/auth';
import { ErrorBoundary, installReporter } from '@micronet/clientreports';
import { AUTH, ENV } from './config/env';
import { LoginRoute, HomeRoute } from './routes';
import './index.css';

// Client error reports go to conciliatron's API, which hosts the endpoint, so
// only a deployment that runs it reports. At module scope, as conciliatron's own
// main does, so a crash before the first render is still caught; its Host hands
// the reporter a token once signed in.
if (ENV.products.includes('conciliatron')) {
  installReporter({
    endpoint: `${ENV.conciliatronApi}/api/v1/client-reports`,
    extraHeaders: import.meta.env.DEV
      ? {
          'X-Authz-User-Id': ENV.authzUserId,
          ...(ENV.workspaceId !== undefined
            ? { 'X-Authz-Workspace-Ids': String(ENV.workspaceId) }
            : {}),
        }
      : undefined,
  });
}

function renderApp() {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ErrorBoundary>
        <AuthProvider config={AUTH}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LoginRoute />} />
              <Route path="/home/*" element={<HomeRoute />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ErrorBoundary>
    </StrictMode>
  );
}

// MSAL's redirect bridge: let it handle an auth response in the URL before rendering.
handleAuthRedirect()
  .then((handled) => {
    if (!handled) renderApp();
  })
  .catch(() => renderApp());
